export enum DocumentsErrorCodes {
  DOCUMENT_ID_NOT_FOUND = 'document_id_not_found',
  DOCUMENT_TYPE_NOT_FOUND = 'document_type_not_found',
  DOCUMENT_FILE_ID_NOT_FOUND = 'document_file_id_not_found',
  DOCUMENT_UPLOAD_FAILED = 'document_upload_failed',
  DOCUMENT_FILE_SIZE_EXCEEDED = 'document_file_size_exceeded',
  DOCUMENT_GENERATION_FAILED = 'document_generation_failed',
  HOLDING_STATEMENT_NOT_IMPLEMENTED = 'holding_statement_not_implemented',
}
